import React, { useState, useEffect, useMemo } from 'react';
import { Types } from 'mongoose';

import { voiceItemWebApiListSettings } from '../../../../util/getVoiceItemSettings';

import SelectWebApi from './SelectWebApi';

export default ({
  doUpdateItem,
  item,
  bot,
  connectors,
  deleteConnectorRequest,
}) => {
  const [itemSettings, setItemSettings] = useState(voiceItemWebApiListSettings);

  useEffect(() => {
    if (item && item.voiceSettings) {
      setItemSettings(item.voiceSettings);
    }
  }, [item]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const newValue = type === 'checkbox' ? checked : value;
    const updatedSettings = { ...itemSettings, [name]: newValue };

    setItemSettings(updatedSettings);
    doUpdateItem({ voiceSettings: updatedSettings });
  };

  const connectorsFromItem = useMemo(() => {
    return connectors?.filter(
      (connector) => String(connector.from) === String(item._id)
    );
  }, [connectors, item?._id]);

  const deleteConnectorsFromItem = () => {
    const { menuItems } = item;
    if (!menuItems) return;

    connectorsFromItem.forEach((connectorItem) => {
      deleteConnectorRequest(connectorItem._id, bot._id);
    });
  };

  const deleteWebApi = () => {
    const updatedVoiceSettings = {
      ...itemSettings,
      idIvrWebApi: null,
      deUrlWebApi: '',
      deParametersWebApi: {},
    };
    const updatedItem = {
      menuItems: [],
      voiceSettings: updatedVoiceSettings,
    };

    setItemSettings(updatedVoiceSettings);
    doUpdateItem(updatedItem);
  };

  const handleChangeWebApi = (e) => {
    const hasConnectorFromItem = connectorsFromItem?.length > 0;

    const abortChange =
      hasConnectorFromItem &&
      !window.confirm(
        'Deseja realmente alterar a api? (Essa ação vai deletar todas as ligações com origem neste bloco)'
      );

    if (abortChange) return;

    deleteConnectorsFromItem();

    const newWebApiId = e.target.value;

    if (!newWebApiId) {
      deleteWebApi();
      return;
    }

    const webApi = e.target.option;
    const webApiFlowOptions = webApi.NmIvrWebApiFlow.split('|');

    const menuItems = Array.isArray(webApiFlowOptions)
      ? webApiFlowOptions.map((option) => {
          const [optionName, optionRequired] = option.split('=');

          return {
            _id: Types.ObjectId().toString(),
            description: optionName,
            require_connection: Boolean(optionRequired),
          };
        })
      : [];

    const params = webApi.DeParametersWebApiExternal?.split?.('/');
    const deParametersWebApi = Array.isArray(params)
      ? params.reduce(
          (acc, paramWebApi) => ({
            ...acc,
            [paramWebApi]: '',
          }),
          {}
        )
      : {};

    const updatedVoiceSettings = {
      ...itemSettings,
      idIvrWebApi: newWebApiId,
      deUrlWebApi: webApi.DeUrlWebApi,
      deParametersWebApi,
    };

    const updatedItem = {
      menuItems,
      voiceSettings: updatedVoiceSettings,
    };

    setItemSettings(updatedVoiceSettings);
    doUpdateItem(updatedItem);
  };

  const handleChangeParametersWebApi = (e) => {
    const { name, value } = e.target;

    const updatedVoiceSettings = {
      ...itemSettings,
      deParametersWebApi: { ...itemSettings.deParametersWebApi, [name]: value },
    };
    setItemSettings(updatedVoiceSettings);
    doUpdateItem({ voiceSettings: updatedVoiceSettings });
  };

  return (
    <>
      <p className="handler-title">API</p>

      <SelectWebApi
        value={itemSettings.idIvrWebApi}
        onChange={handleChangeWebApi}
      />

      <div className="common-form-group">
        <label>Url da API</label>
        <input
          className="form-control mt-1"
          value={itemSettings.deUrlWebApi}
          disabled
        />
      </div>

      {itemSettings?.deParametersWebApi &&
        Object.keys(itemSettings.deParametersWebApi).map((key) => {
          const paramValue = itemSettings.deParametersWebApi[key];
          return (
            <div className="common-form-group" key={key}>
              <label>{key}</label>
              <input
                className="form-control mt-1"
                value={paramValue}
                name={key}
                onChange={handleChangeParametersWebApi}
                placeholder="Informe a fonte de dados"
              />
            </div>
          );
        })}

      <div className="common-form-group">
        <label>Código externo para cliente (opcional)</label>
        <input
          className="form-control mt-1"
          value={itemSettings.codeIvrStepExternal}
          name="codeIvrStepExternal"
          onChange={handleInputChange}
        />
      </div>

      <div className="form-group row mb-1">
        <div className="custom-control custom-switch mt-2">
          <input
            type="checkbox"
            className="custom-control-input"
            name="isCpc"
            id="isCpc"
            checked={itemSettings.isCpc}
            onChange={handleInputChange}
          />
          <label className="custom-control-label" htmlFor="isCpc">
            É CPC
          </label>
        </div>
      </div>
    </>
  );
};
